/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface OfficeRegionsService {
  /** @summary Get All */
  getAllOfficeRegionsGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllOfficeRegionsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllOfficeRegionsGetSchema,
        options: {
          parameters: GetAllOfficeRegionsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError>>
    ): Promise<RequestFnResponse<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllOfficeRegionsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officeRegionsService.getAllOfficeRegionsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllOfficeRegionsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllOfficeRegionsGetData,
          GetAllOfficeRegionsGetError,
          TData,
          ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllOfficeRegionsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officeRegionsService.getAllOfficeRegionsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllOfficeRegionsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllOfficeRegionsGetData,
          GetAllOfficeRegionsGetError,
          TData,
          ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllOfficeRegionsGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllOfficeRegionsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeRegionsService.getAllOfficeRegionsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllOfficeRegionsGetParameters,
      TQueryFnData = GetAllOfficeRegionsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllOfficeRegionsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllOfficeRegionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllOfficeRegionsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeRegionsService.getAllOfficeRegionsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllOfficeRegionsGetParameters,
      TQueryFnData = GetAllOfficeRegionsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllOfficeRegionsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllOfficeRegionsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllOfficeRegionsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllOfficeRegionsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllOfficeRegionsGetTotal = qraft.officeRegionsService.getAllOfficeRegionsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllOfficeRegionsGetResults = qraft.officeRegionsService.getAllOfficeRegionsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOfficeRegionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllOfficeRegionsGetCombinedResults = qraft.officeRegionsService.getAllOfficeRegionsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOfficeRegionsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllOfficeRegionsGetSchema,
          GetAllOfficeRegionsGetParameters,
          GetAllOfficeRegionsGetData,
          GetAllOfficeRegionsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.officeRegionsService.getAllOfficeRegionsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllOfficeRegionsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllOfficeRegionsGetData,
          GetAllOfficeRegionsGetError,
          TData,
          ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllOfficeRegionsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeRegionsService.getAllOfficeRegionsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllOfficeRegionsGetParameters, TData = GetAllOfficeRegionsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllOfficeRegionsGetData,
          GetAllOfficeRegionsGetError,
          OperationInfiniteData<TData, GetAllOfficeRegionsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllOfficeRegionsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllOfficeRegionsGetParameters>,
      OperationError<GetAllOfficeRegionsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllOfficeRegionsGetData = qraft.officeRegionsService.getAllOfficeRegionsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOfficeRegionsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllOfficeRegionsGetCombinedData = qraft.officeRegionsService.getAllOfficeRegionsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOfficeRegionsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllOfficeRegionsGetSchema,
          GetAllOfficeRegionsGetParameters,
          GetAllOfficeRegionsGetData,
          GetAllOfficeRegionsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        GetAllOfficeRegionsGetParameters,
        GetAllOfficeRegionsGetError
      > | void
    ): Promise<GetAllOfficeRegionsGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        GetAllOfficeRegionsGetParameters,
        GetAllOfficeRegionsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        GetAllOfficeRegionsGetParameters,
        GetAllOfficeRegionsGetError
      > | void
    ): Promise<GetAllOfficeRegionsGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllOfficeRegionsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        GetAllOfficeRegionsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllOfficeRegionsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllOfficeRegionsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        GetAllOfficeRegionsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllOfficeRegionsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllOfficeRegionsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        GetAllOfficeRegionsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllOfficeRegionsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void)
    ): GetAllOfficeRegionsGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void)
    ): OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
            data:
              | NoInfer<OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
            data: GetAllOfficeRegionsGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | void)
    ): QueryState<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllOfficeRegionsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters>,
          GetAllOfficeRegionsGetError
        >
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
      updater: Updater<
        NoInfer<GetAllOfficeRegionsGetData> | undefined,
        NoInfer<DeepReadonly<GetAllOfficeRegionsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllOfficeRegionsGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllOfficeRegionsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllOfficeRegionsGetSchema, GetAllOfficeRegionsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllOfficeRegionsGetData, GetAllOfficeRegionsGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >,
      updater: Updater<
        NoInfer<GetAllOfficeRegionsGetData> | undefined,
        NoInfer<GetAllOfficeRegionsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllOfficeRegionsGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllOfficeRegionsGetSchema,
        GetAllOfficeRegionsGetData,
        TInfinite,
        GetAllOfficeRegionsGetParameters,
        GetAllOfficeRegionsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOfficeRegionsGetSchema,
            GetAllOfficeRegionsGetData,
            TInfinite,
            GetAllOfficeRegionsGetParameters,
            GetAllOfficeRegionsGetError
          >
    ): number;
    schema: GetAllOfficeRegionsGetSchema;
    types: {
      parameters: GetAllOfficeRegionsGetParameters;
      data: GetAllOfficeRegionsGetData;
      error: GetAllOfficeRegionsGetError;
    };
  };
  /** @summary Create */
  createOfficeRegionsPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateOfficeRegionsPostBody,
        CreateOfficeRegionsPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateOfficeRegionsPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateOfficeRegionsPostBody,
          CreateOfficeRegionsPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateOfficeRegionsPostData, CreateOfficeRegionsPostError>>
    ): Promise<RequestFnResponse<CreateOfficeRegionsPostData, CreateOfficeRegionsPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateOfficeRegionsPostParameters> | void
    ): ServiceOperationMutationKey<CreateOfficeRegionsPostSchema, CreateOfficeRegionsPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.createOfficeRegionsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.createOfficeRegionsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateOfficeRegionsPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateOfficeRegionsPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateOfficeRegionsPostSchema,
        CreateOfficeRegionsPostData,
        CreateOfficeRegionsPostParameters,
        TVariables,
        OperationError<CreateOfficeRegionsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateOfficeRegionsPostData,
      OperationError<CreateOfficeRegionsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.createOfficeRegionsPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.createOfficeRegionsPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateOfficeRegionsPostBody, CreateOfficeRegionsPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateOfficeRegionsPostSchema,
        CreateOfficeRegionsPostData,
        CreateOfficeRegionsPostParameters,
        TVariables,
        OperationError<CreateOfficeRegionsPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateOfficeRegionsPostData,
      OperationError<CreateOfficeRegionsPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createOfficeRegionsPostTotal = qraft.officeRegionsService.createOfficeRegionsPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createOfficeRegionsPostTotal = qraft.officeRegionsService.createOfficeRegionsPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateOfficeRegionsPostBody,
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostParameters,
            OperationError<CreateOfficeRegionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateOfficeRegionsPostSchema,
            CreateOfficeRegionsPostBody,
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostParameters,
            OperationError<CreateOfficeRegionsPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createOfficeRegionsPostPendingMutationVariables = qraft.officeRegionsService.createOfficeRegionsPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createOfficeRegionsPostMutationData = qraft.officeRegionsService.createOfficeRegionsPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateOfficeRegionsPostData,
        OperationError<CreateOfficeRegionsPostError>,
        MutationVariables<CreateOfficeRegionsPostBody, CreateOfficeRegionsPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateOfficeRegionsPostBody,
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostParameters,
            OperationError<CreateOfficeRegionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateOfficeRegionsPostSchema,
            CreateOfficeRegionsPostBody,
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostParameters,
            OperationError<CreateOfficeRegionsPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateOfficeRegionsPostData,
          OperationError<CreateOfficeRegionsPostError>,
          MutationVariables<CreateOfficeRegionsPostBody, CreateOfficeRegionsPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateOfficeRegionsPostBody,
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostParameters,
            OperationError<CreateOfficeRegionsPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateOfficeRegionsPostSchema,
            CreateOfficeRegionsPostBody,
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostParameters,
            OperationError<CreateOfficeRegionsPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officeRegionsService.createOfficeRegionsPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officeRegionsService.createOfficeRegionsPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateOfficeRegionsPostBody,
              CreateOfficeRegionsPostData,
              CreateOfficeRegionsPostParameters,
              OperationError<CreateOfficeRegionsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateOfficeRegionsPostSchema,
              CreateOfficeRegionsPostBody,
              CreateOfficeRegionsPostData,
              CreateOfficeRegionsPostParameters,
              OperationError<CreateOfficeRegionsPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateOfficeRegionsPostData,
            CreateOfficeRegionsPostError,
            MutationVariables<CreateOfficeRegionsPostBody, CreateOfficeRegionsPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateOfficeRegionsPostBody,
              CreateOfficeRegionsPostData,
              CreateOfficeRegionsPostParameters,
              OperationError<CreateOfficeRegionsPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateOfficeRegionsPostSchema,
              CreateOfficeRegionsPostBody,
              CreateOfficeRegionsPostData,
              CreateOfficeRegionsPostParameters,
              OperationError<CreateOfficeRegionsPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateOfficeRegionsPostData,
          CreateOfficeRegionsPostError,
          MutationVariables<CreateOfficeRegionsPostBody, CreateOfficeRegionsPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateOfficeRegionsPostSchema;
    types: {
      parameters: CreateOfficeRegionsPostParameters;
      data: CreateOfficeRegionsPostData;
      error: CreateOfficeRegionsPostError;
      body: CreateOfficeRegionsPostBody;
    };
  };
  /** @summary Update */
  updateOfficeRegionsRegionIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateOfficeRegionsRegionIdPatchBody,
        UpdateOfficeRegionsRegionIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateOfficeRegionsRegionIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateOfficeRegionsRegionIdPatchBody,
          UpdateOfficeRegionsRegionIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateOfficeRegionsRegionIdPatchData, UpdateOfficeRegionsRegionIdPatchError>>
    ): Promise<RequestFnResponse<UpdateOfficeRegionsRegionIdPatchData, UpdateOfficeRegionsRegionIdPatchError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateOfficeRegionsRegionIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateOfficeRegionsRegionIdPatchSchema, UpdateOfficeRegionsRegionIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useMutation({
     *     path: {
     *         region_id: regionId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         region_id: regionId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateOfficeRegionsRegionIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateOfficeRegionsRegionIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateOfficeRegionsRegionIdPatchSchema,
        UpdateOfficeRegionsRegionIdPatchData,
        UpdateOfficeRegionsRegionIdPatchParameters,
        TVariables,
        OperationError<UpdateOfficeRegionsRegionIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateOfficeRegionsRegionIdPatchData,
      OperationError<UpdateOfficeRegionsRegionIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useMutation({
     *     path: {
     *         region_id: regionId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         region_id: regionId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateOfficeRegionsRegionIdPatchBody,
        UpdateOfficeRegionsRegionIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateOfficeRegionsRegionIdPatchSchema,
        UpdateOfficeRegionsRegionIdPatchData,
        UpdateOfficeRegionsRegionIdPatchParameters,
        TVariables,
        OperationError<UpdateOfficeRegionsRegionIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateOfficeRegionsRegionIdPatchData,
      OperationError<UpdateOfficeRegionsRegionIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateOfficeRegionsRegionIdPatchTotal = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateOfficeRegionsRegionIdPatchTotal = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             region_id: regionId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateOfficeRegionsRegionIdPatchBody,
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchParameters,
            OperationError<UpdateOfficeRegionsRegionIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateOfficeRegionsRegionIdPatchSchema,
            UpdateOfficeRegionsRegionIdPatchBody,
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchParameters,
            OperationError<UpdateOfficeRegionsRegionIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateOfficeRegionsRegionIdPatchPendingMutationVariables = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateOfficeRegionsRegionIdPatchMutationData = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 region_id: regionId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateOfficeRegionsRegionIdPatchData,
        OperationError<UpdateOfficeRegionsRegionIdPatchError>,
        MutationVariables<UpdateOfficeRegionsRegionIdPatchBody, UpdateOfficeRegionsRegionIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateOfficeRegionsRegionIdPatchBody,
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchParameters,
            OperationError<UpdateOfficeRegionsRegionIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateOfficeRegionsRegionIdPatchSchema,
            UpdateOfficeRegionsRegionIdPatchBody,
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchParameters,
            OperationError<UpdateOfficeRegionsRegionIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateOfficeRegionsRegionIdPatchData,
          OperationError<UpdateOfficeRegionsRegionIdPatchError>,
          MutationVariables<UpdateOfficeRegionsRegionIdPatchBody, UpdateOfficeRegionsRegionIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateOfficeRegionsRegionIdPatchBody,
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchParameters,
            OperationError<UpdateOfficeRegionsRegionIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateOfficeRegionsRegionIdPatchSchema,
            UpdateOfficeRegionsRegionIdPatchBody,
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchParameters,
            OperationError<UpdateOfficeRegionsRegionIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             region_id: regionId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officeRegionsService.updateOfficeRegionsRegionIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateOfficeRegionsRegionIdPatchBody,
              UpdateOfficeRegionsRegionIdPatchData,
              UpdateOfficeRegionsRegionIdPatchParameters,
              OperationError<UpdateOfficeRegionsRegionIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateOfficeRegionsRegionIdPatchSchema,
              UpdateOfficeRegionsRegionIdPatchBody,
              UpdateOfficeRegionsRegionIdPatchData,
              UpdateOfficeRegionsRegionIdPatchParameters,
              OperationError<UpdateOfficeRegionsRegionIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateOfficeRegionsRegionIdPatchData,
            UpdateOfficeRegionsRegionIdPatchError,
            MutationVariables<UpdateOfficeRegionsRegionIdPatchBody, UpdateOfficeRegionsRegionIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateOfficeRegionsRegionIdPatchBody,
              UpdateOfficeRegionsRegionIdPatchData,
              UpdateOfficeRegionsRegionIdPatchParameters,
              OperationError<UpdateOfficeRegionsRegionIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateOfficeRegionsRegionIdPatchSchema,
              UpdateOfficeRegionsRegionIdPatchBody,
              UpdateOfficeRegionsRegionIdPatchData,
              UpdateOfficeRegionsRegionIdPatchParameters,
              OperationError<UpdateOfficeRegionsRegionIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateOfficeRegionsRegionIdPatchData,
          UpdateOfficeRegionsRegionIdPatchError,
          MutationVariables<UpdateOfficeRegionsRegionIdPatchBody, UpdateOfficeRegionsRegionIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateOfficeRegionsRegionIdPatchSchema;
    types: {
      parameters: UpdateOfficeRegionsRegionIdPatchParameters;
      data: UpdateOfficeRegionsRegionIdPatchData;
      error: UpdateOfficeRegionsRegionIdPatchError;
      body: UpdateOfficeRegionsRegionIdPatchBody;
    };
  };
  /** @summary Remove */
  removeOfficeRegionsRegionIdDelete: {
    /** @summary Remove */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RemoveOfficeRegionsRegionIdDeleteBody,
        RemoveOfficeRegionsRegionIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RemoveOfficeRegionsRegionIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          RemoveOfficeRegionsRegionIdDeleteBody,
          RemoveOfficeRegionsRegionIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RemoveOfficeRegionsRegionIdDeleteData, RemoveOfficeRegionsRegionIdDeleteError>>
    ): Promise<RequestFnResponse<RemoveOfficeRegionsRegionIdDeleteData, RemoveOfficeRegionsRegionIdDeleteError>>;
    /** @summary Remove */
    getMutationKey(
      parameters: DeepReadonly<RemoveOfficeRegionsRegionIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      RemoveOfficeRegionsRegionIdDeleteSchema,
      RemoveOfficeRegionsRegionIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useMutation({
     *     path: {
     *         region_id: regionId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         region_id: regionId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RemoveOfficeRegionsRegionIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<RemoveOfficeRegionsRegionIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        RemoveOfficeRegionsRegionIdDeleteSchema,
        RemoveOfficeRegionsRegionIdDeleteData,
        RemoveOfficeRegionsRegionIdDeleteParameters,
        TVariables,
        OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveOfficeRegionsRegionIdDeleteData,
      OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useMutation({
     *     path: {
     *         region_id: regionId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         region_id: regionId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        RemoveOfficeRegionsRegionIdDeleteBody,
        RemoveOfficeRegionsRegionIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RemoveOfficeRegionsRegionIdDeleteSchema,
        RemoveOfficeRegionsRegionIdDeleteData,
        RemoveOfficeRegionsRegionIdDeleteParameters,
        TVariables,
        OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveOfficeRegionsRegionIdDeleteData,
      OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const removeOfficeRegionsRegionIdDeleteTotal = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const removeOfficeRegionsRegionIdDeleteTotal = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             region_id: regionId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RemoveOfficeRegionsRegionIdDeleteBody,
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteParameters,
            OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveOfficeRegionsRegionIdDeleteSchema,
            RemoveOfficeRegionsRegionIdDeleteBody,
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteParameters,
            OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const removeOfficeRegionsRegionIdDeletePendingMutationVariables = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const removeOfficeRegionsRegionIdDeleteMutationData = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 region_id: regionId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RemoveOfficeRegionsRegionIdDeleteData,
        OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
        MutationVariables<RemoveOfficeRegionsRegionIdDeleteBody, RemoveOfficeRegionsRegionIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RemoveOfficeRegionsRegionIdDeleteBody,
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteParameters,
            OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveOfficeRegionsRegionIdDeleteSchema,
            RemoveOfficeRegionsRegionIdDeleteBody,
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteParameters,
            OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RemoveOfficeRegionsRegionIdDeleteData,
          OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
          MutationVariables<RemoveOfficeRegionsRegionIdDeleteBody, RemoveOfficeRegionsRegionIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Remove */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RemoveOfficeRegionsRegionIdDeleteBody,
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteParameters,
            OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveOfficeRegionsRegionIdDeleteSchema,
            RemoveOfficeRegionsRegionIdDeleteBody,
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteParameters,
            OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             region_id: regionId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officeRegionsService.removeOfficeRegionsRegionIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RemoveOfficeRegionsRegionIdDeleteBody,
              RemoveOfficeRegionsRegionIdDeleteData,
              RemoveOfficeRegionsRegionIdDeleteParameters,
              OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveOfficeRegionsRegionIdDeleteSchema,
              RemoveOfficeRegionsRegionIdDeleteBody,
              RemoveOfficeRegionsRegionIdDeleteData,
              RemoveOfficeRegionsRegionIdDeleteParameters,
              OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            RemoveOfficeRegionsRegionIdDeleteData,
            RemoveOfficeRegionsRegionIdDeleteError,
            MutationVariables<RemoveOfficeRegionsRegionIdDeleteBody, RemoveOfficeRegionsRegionIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RemoveOfficeRegionsRegionIdDeleteBody,
              RemoveOfficeRegionsRegionIdDeleteData,
              RemoveOfficeRegionsRegionIdDeleteParameters,
              OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveOfficeRegionsRegionIdDeleteSchema,
              RemoveOfficeRegionsRegionIdDeleteBody,
              RemoveOfficeRegionsRegionIdDeleteData,
              RemoveOfficeRegionsRegionIdDeleteParameters,
              OperationError<RemoveOfficeRegionsRegionIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          RemoveOfficeRegionsRegionIdDeleteData,
          RemoveOfficeRegionsRegionIdDeleteError,
          MutationVariables<RemoveOfficeRegionsRegionIdDeleteBody, RemoveOfficeRegionsRegionIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: RemoveOfficeRegionsRegionIdDeleteSchema;
    types: {
      parameters: RemoveOfficeRegionsRegionIdDeleteParameters;
      data: RemoveOfficeRegionsRegionIdDeleteData;
      error: RemoveOfficeRegionsRegionIdDeleteError;
      body: RemoveOfficeRegionsRegionIdDeleteBody;
    };
  };
}
/** @summary Get All */
export const getAllOfficeRegionsGet = {
  schema: {
    method: 'get',
    url: '/office_regions',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllOfficeRegionsGetSchema;
  [QraftServiceOperationsToken]: OfficeRegionsService['getAllOfficeRegionsGet'];
};
/** @summary Create */
export const createOfficeRegionsPost = {
  schema: {
    method: 'post',
    url: '/office_regions',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateOfficeRegionsPostSchema;
  [QraftServiceOperationsToken]: OfficeRegionsService['createOfficeRegionsPost'];
};
/** @summary Update */
export const updateOfficeRegionsRegionIdPatch = {
  schema: {
    method: 'patch',
    url: '/office_regions/{region_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateOfficeRegionsRegionIdPatchSchema;
  [QraftServiceOperationsToken]: OfficeRegionsService['updateOfficeRegionsRegionIdPatch'];
};
/** @summary Remove */
export const removeOfficeRegionsRegionIdDelete = {
  schema: {
    method: 'delete',
    url: '/office_regions/{region_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: RemoveOfficeRegionsRegionIdDeleteSchema;
  [QraftServiceOperationsToken]: OfficeRegionsService['removeOfficeRegionsRegionIdDelete'];
};
export const officeRegionsService = {
  getAllOfficeRegionsGet,
  createOfficeRegionsPost,
  updateOfficeRegionsRegionIdPatch,
  removeOfficeRegionsRegionIdDelete,
} as const;
type GetAllOfficeRegionsGetSchema = {
  method: 'get';
  url: '/office_regions';
  security: ['HTTPBearer'];
};
type GetAllOfficeRegionsGetParameters = undefined;
type GetAllOfficeRegionsGetData = paths['/office_regions']['get']['responses']['200']['content']['application/json'];
type GetAllOfficeRegionsGetError = unknown;
type CreateOfficeRegionsPostSchema = {
  method: 'post';
  url: '/office_regions';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateOfficeRegionsPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateOfficeRegionsPostData = paths['/office_regions']['post']['responses']['200']['content']['application/json'];
type CreateOfficeRegionsPostError = paths['/office_regions']['post']['responses']['422']['content']['application/json'];
type CreateOfficeRegionsPostBody = paths['/office_regions']['post']['requestBody']['content']['application/json'];
type UpdateOfficeRegionsRegionIdPatchSchema = {
  method: 'patch';
  url: '/office_regions/{region_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateOfficeRegionsRegionIdPatchParameters = paths['/office_regions/{region_id}']['patch']['parameters'];
type UpdateOfficeRegionsRegionIdPatchData =
  paths['/office_regions/{region_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateOfficeRegionsRegionIdPatchError =
  paths['/office_regions/{region_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateOfficeRegionsRegionIdPatchBody =
  paths['/office_regions/{region_id}']['patch']['requestBody']['content']['application/json'];
type RemoveOfficeRegionsRegionIdDeleteSchema = {
  method: 'delete';
  url: '/office_regions/{region_id}';
  security: ['HTTPBearer'];
};
type RemoveOfficeRegionsRegionIdDeleteParameters = paths['/office_regions/{region_id}']['delete']['parameters'];
type RemoveOfficeRegionsRegionIdDeleteData =
  paths['/office_regions/{region_id}']['delete']['responses']['200']['content']['application/json'];
type RemoveOfficeRegionsRegionIdDeleteError =
  paths['/office_regions/{region_id}']['delete']['responses']['422']['content']['application/json'];
type RemoveOfficeRegionsRegionIdDeleteBody = undefined;
